
import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import App from "../components/appStartkit";
import AppOralB from "../components/appOralB";

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
        <Breadcrumb category={["nyheter", "nyheter"]}  page={["Gula tänder", "gula-tander"]}/>
     <SEO title="Gula tänder" description="Varför får man gula tänder"/>
     <section className="section-metoder">
     <main>
       <h1 class="welcome">Gula tänder</h1>
       <p class="text-center">
      Missfärgningar och fläckar på tänderna kan ha flera orsaker. Till exempel om man stoppar i sig stora mängder tobak, 
      kaffe, te och vin. Även vissa mediciner, ålder och sjukdom kan göra att tänderna mörknar och blir gulare. </p>
      <h2>Hur får man vita tänder?</h2>
       <p class="text-center">Det räcker som sagt bara inte och borsta sina tänder över tid, för att slippa gula tänder. 
       Det går också att göra tandblekning på klinik, om man vill göra det på ett professionellt sätt, men det kostar 
       också en del pengar. Man kan också göra en tandblekning själv hemma, med hjälp av olika metoder, för att slippa 
       gula tänder. Även medicin och sjukdom kan påverka dina tänder negativt. Dessutom kan plack och för dålig borstning 
       samt rengöring mellan tänderna göra att du får gulaktiga tänder. Tyvärr så kan också naturliga orsaker som ditt 
       arv göra att du har en gulare emalj redan från ung ålder. När din emalj börjar tappa sin tjocklek blir dentinet 
       under mycket mer synligt och gör att dina tänder ser gula ut. 
       </p>
       <p class="text-center">
       Vår emalj blir tunnare när vi åldras, men syror från mat och dryck kan orsaka att emalj eroderas för tidigt och 
       gör att tänderna blir gula.</p>
        <h2>Hur förhindrar du gula tänder?</h2>
      <p class="text-center">Du kan förhindra gula tänder genom att undvika söta snacks och sura drycker som läsk. 
      Syrorna från dessa livsmedel kan erodera din emalj, men om du dricker mjölk eller vanligt vatten efter att 
      måltiderna kan det hjälpa till att motverka effekterna.</p>
<p class="text-center">
Ett annat sätt att förhindra gula tänder är att begränsa hur mycket du småäter mellan måltiderna. Om du gör det kan din saliv naturligt späda ut några av syrorna i munnen.
</p><p class="text-center">
Nu när du vet vad som orsakar gula tänder blir det lättare för dig att hålla tänderna rena. Kom bara ihåg att vara uppmärksam på vad du äter.
</p><p class="text-center">
Mat och dryck som kan lättare ge gula tänder:
<ul style={{listStyleType: "none"}}>
<li>Te</li>
<li>Kaffe</li>
<li>Coladrycker</li>
<li>Rödvin</li>
<li>Mörka bär som blåbär och björnbär</li>
<li>Rödbetor</li>
</ul>
</p>
</main>
</section>
<section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  <section className="section-metoder">
     <main>
<p class="text-center">
<h3 class="welcome">1. Byt till eltandborste</h3> 
        Med eltandborste får vi lättare bort plack, och ofta finns flera inställningar för skräddarsydd borstning. Var bara noga med att följa instruktionerna.
        </p><p class="text-center">
        <h3 class="welcome">2. Gnugga i stället för borsta</h3> 
        Blödande tandkött beror på inflammation orsakad av kvardröjande bakterier. Att köra borsten fram och tillbaka sidledes är helt fel - den rätta tekniken är att försiktigt gnugga borsten i nedåtgående riktning (uppåt på undertänderna) vid tandköttskanten för att få bort bakterier och plack utan slitage. Tandhygienisten Pia Ekman på Aqua Dental rekommenderar tio sekunder per tand.
        </p><p class="text-center">
        <h3 class="welcome">3. Rengör rätt</h3>  
        Julia Roberts hade rätt i Pretty woman - rengöring mellan tänderna är viktigt. Mellanrumsborstar är ännu bättre än tandtråd och fångar upp bakterier och plack mellan tänderna (vi gillar Tepes mellanrumsborstar). Tandhygienisten Pia Ekman rekommenderar tio borstdrag mellan varje tandpar morgon och kväll. Använd mellanrumsborsten efter fluorborstning och floursköljning, så får du in fluoret mellan tänderna.
        </p><p class="text-center">
        <h3 class="welcome">4. Prioritera din tandfe</h3> 
        Tandhygienisten är tändernas bästa vän. Vi går på ansiktsbehandling, manikyr och till frisören, men att underhålla tänderna glöms ofta bort innan man börjar få problem. Förebygg allt från karies, tandköttsinflammation och tandlossning till estetiska bekymmer med ett tandhygienistsbesök i halvåret. Tandhygienisten rengör tänderna grundligt, kollar tandköttsstatus, tar bort tandsten och polerar bort ytliga missfärgningar. Tänk på besöket som en ansiktsbehandling (med peeling och portömning!) för tänderna, och det känns genast mer lockande.
        Underhåll dina blekta tänder hemma med whitening-tandkräm
        </p>

          </main>
          </section>
              <section className="section-cards">
      <main className="card__ai">
        <h2 class="card-rubrik">Startkit</h2>
        <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
        <App />
        </main>
      </section>
      <section className="section-metoder">
      <main>
        <h3 class="welcome">5. Tandkräm för vitare tänder</h3> <p class="text-center">
        Oavsett om du har blekt dina tänder hemma eller på klinik, underhåll resultatet hemma med en whitening-tandkräm och fluorskölj. Du får bort ytliga missfärgningar från kaffe, rött vin och färgad mat så att ditt fina resultat från blekningen håller längre. Välj alltid tandkräm och munskölj med fluor för att motverka karies, och vänta minst en timme med att äta eller dricka så att fluoret hinner verka.
        </p><p class="text-center">
        <h3 class="welcome">6. Sippa ur sugrör</h3> 
        Gröna juicer och citronvatten är trendigt och hälsosamt, men citrus och sura frukter kan ha en frätande effekt på emaljen. Drick juicen ur sugrör (men välj ett som inte är av plast, för miljöns skull), så blir kontakten med tandytorna minimal. Borsta aldrig tänderna tidigare än en halvtimme efter drickandet, eftersom du riskerar att slita på tandytan som syrorna luckrat upp - borsta hellre före sippandet. Läsk skippar vi helst helt eftersom sött i kombo med kolsyra är en mardröm för gaddarna.
        </p>
      </main> 
              <section className="section-cards">
             <main className="card__ai">
        <h2 class="card-rubrik">Våra favoriter</h2>
        <h3 class="card__smRubrik">Ta hand om dina tänder</h3>
        <AppOralB />
        </main>
        </section>
        <main> 
        <p class="text-center">
          
        <h3 class="welcome">7. Småät mindre </h3>
        Vi lever i snacksandets tid - mellanmålsbars, fikaraster och fruktkorgar inbjuder till konstant småätande. Tandhygiensten Anna-Karin Karlsson på Tandläkarhuset Bromma rekommenderar att hålla sig till tre huvudmål och ta ett tuggummi med tandstärkande fluor och xylitol efter maten - det stimulerar salivutsöndringen och buffrar lågt pH, som är viktigt för munhälsan, säger hon.
        </p><p class="text-center">
        <h3 class="welcome">8. Håll koll på käkarna </h3>
        Vaknar du med huvudvärk och ömma käkar är risken stor att du är en nattpressare. Ungefär var tredje vuxen uppskattas gnissla eller pressa tänder på grund av stress. En bettskena tar inte bort stressen, men skyddar tandytorna mot att nötas ner, skadas eller spricka. Tandläkaren beställer en bettskena skräddarsydd efter din mun, och det är en prisvärd investering som kan spara många tusenlappar för skadade tänder på sikt. Botox som försvagar käkmusklerna är också en mycket effektiv metod, som även ger ansiktet en nättare form.
        Läppstift med blå undertoner får tänderna att framstå som vitare
        </p><p class="text-center">
        <h3 class="welcome">9. Var läppstiftscool</h3> 
        Läppstift med blå undertoner får tänderna att framstå som vitare, medan gula och orange undertoner förstärker gulnad. Satsa på svala nyanser av rosa eller rött.
       </p>
       </main>

     </section>


  </Layout2>
)

export default IndexPage
